import { NgZorroAntdModule } from 'src/app/ng-zorro-antd.module';
import { NgModule } from '@angular/core';
import { DefaultLayoutRoutes } from './default-layout.routing';
import { SharedModule } from '../shared/shared.module';
import { DefaultLayoutComponent } from './default-layout.component';
import { LandingModule } from 'src/app/modules/landing/landing.module';

@NgModule({
  imports: [
    SharedModule,
    DefaultLayoutRoutes,
    NgZorroAntdModule,
    LandingModule,
  
  ],
  declarations: [DefaultLayoutComponent],
})
export class DefaultLayoutModule {}
